import IMask from "imask";

export default class Credit {
  constructor() {
    this.setFieldMask();
  }

  setFieldMask() {
    const installmentsValue = document.querySelector(
      "#woocommerce_vindi-pagamentos-credit_installments_value",
    );
    if (installmentsValue) {
      IMask(installmentsValue, {
        mask: "R$00,00",
      });
    }
  }
}
